export default __webpack_public_path__ + "static/media/Group_88.54b78235.png";